
<template>
    <div id="social-buttons">
        <ul>
            <slot></slot>
        </ul>
    </div>
</template>

<script>

    var __mixin = {
        modal: {
            template: `<li><a @click.prevent="$parent.share(network, true)"> <slot></slot> </a></li>`
        },
        link: {
            template: `<li><a :href="$parent.networks[network].sharer" @click="$parent.share(network, false)"> <slot></slot> </a></li>`
        }

    }
    
export default {

    mounted: function() {

    },
    
    props: {
        url: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: 'undefined'
        },
        description: {
            type: String,
            default: 'undefined'
        },
        twitteruser: {
            type: String,
            default: 'twitter'
        },
        emailurl: {
            type: String,
            default: null
        }
    },

    data: function() {
        return {
            networks: {
                facebook: {
                    sharer: `https://www.facebook.com/sharer/sharer.php?u=${this.url}&summary=${this.title}`,
                    stats: `https://api.facebook.com/method/links.getStats?urls=${this.url}&format=json`,
                },
                twitter: {
                    sharer: `https://twitter.com/intent/tweet?text=${this.title.substring(0,80)}&url=${this.url}&via=${this.twitteruser}`
                },
                googleplus: {
                    sharer: `https://plus.google.com/share?url=${this.url}`,
                    stats: `https://plusone.google.com/_/+1/fastbutton?url=${this.url}`,
                },
                linkedin: {
                    sharer: `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}&title=${this.title}&summary=${this.description}`,
                },
                whatsapp: {
                    sharer: `whatsapp://send?text=${this.title} ${this.url}`,
                },
                email: {
                    sharer: this.emailurl || `mailto:?subject=${this.title}&body=${this.description}%0D%0A%0D%0A${this.url}`
                }
            }
        }
    },

    methods: {
        share: function(network, isLink) {
            this.$emit('action-'+network);
            if(isLink) this.openModal(this.networks[network].sharer);
        },

        openModal: function(url) {
            let y = window.top.outerHeight / 2 + window.top.screenY - ( 436 / 2);
            let x = window.top.outerWidth / 2 + window.top.screenX - ( 626 / 2);

            window.open(
                url,
                'Social Share',
                'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=true, copyhistory=no, width=626, height=436, top='+y+', left='+x
            );
        }
    },

    components: {
        facebook: {
            mixins: [__mixin.modal],
            data: function() { return { network: 'facebook' } },
        },
        twitter: {
            mixins: [__mixin.modal],
            data: function() { return { network: 'twitter' } }
        },
        googleplus: {
            mixins: [__mixin.modal],
            data: function() { return { network: 'googleplus' }}
        },
        linkedin: {
            mixins: [__mixin.modal],
            data: function() { return { network: 'linkedin' }}
        },
        email: {
            mixins: [__mixin.link],
            data: function() { return { network: 'email' }}
        },
        whatsapp: {
            mixins: [__mixin.link],
            data: function() {return { network: 'whatsapp' }}
        }
    

    }
}

</script>

<style lang="scss">
    @import "./../../sass/variables";


</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SocialButtons.vue